import { t } from 'i18next';
import * as yup from 'yup';

import { AutocompleteFieldOption } from '~components/FormFields/v2/Autocomplete/types';
import { CompanyBasic } from '~hooks/useCompany/models';
import { Department } from '~hooks/useDepartment/models';
import UserStore from '~store/UserStore';

export const departmentSchema = yup.object().shape({
  company: yup
    .object()
    .shape({
      label: yup.string().trim().required(),
      value: yup.string().trim().required(),
    })
    .required(t('form_validation_errors.required_simple')),
  name: yup
    .string()
    .trim()
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
});

export type DepartmentDto = yup.InferType<typeof departmentSchema>;
export type DepartmentDtoAsyncError = {
  field: keyof DepartmentDto;
  message: string;
};

export const setDepartmentSchemaDefaultValues = (
  userStore: UserStore,
  department?: Department,
) => {
  const companyFromStore = userStore.currentCompanies[0] || userStore.user.company;
  const company = department?.company
    ? { label: department.company.legalName, value: department.company.id }
    : companyFromStore
      ? { label: companyFromStore.legalName, value: companyFromStore.id }
      : null;

  const defaultValues: DepartmentDto = {
    company: company as AutocompleteFieldOption<CompanyBasic>,
    name: department?.name ?? '',
  };

  return defaultValues;
};
